import { Box, Container, Spinner, Text } from '@theme-ui/components'
import { BsFillFileEarmarkTextFill } from 'react-icons/bs'
import { useQuery } from 'react-query'
import api from '../../api/api'
import { Table } from '../../components'
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import { PanelComponent } from '../../components/Panel/Panel'
import { date } from '../../utils/formatter'

const ListArchivedLaporanPengaduan = () => {
  const { data: dataApi, isLoading } = useQuery<any>('get-reports', () => {
    return api.get(`/reports`, {
      params: {
        'q[no_or_state_cont]': 'archived',
        limit: 50,
      },
    })
  })

  const columns = [
    {
      Header: 'No',
      accessor: 'num',
      width: '5%',
    },
    {
      Header: 'No. Laporan',
      accessor: 'no',
    },
    {
      Header: 'Pengaduan',
      accessor: 'pengaduan',
    },
    {
      Header: 'Tanggal Pengaduan',
      accessor: 'dateComplaint',
    },
    {
      Header: 'Channel',
      accessor: 'channel',
    },
    {
      Header: 'Status',
      accessor: 'state',
    },
  ]

  const dataReports =
    dataApi?.data?.data.map((data, idx) => {
      return { ...data, num: idx + 1, dateComplaint: date(data.dateComplaint) }
    }) || []

  if (isLoading) {
    return (
      <Box sx={{ textAlign: 'center', py: 15 }}>
        <Spinner />
      </Box>
    )
  }

  return (
    <Container sx={{ px: 4, py: 2 }}>
      <Box sx={{ mb: 3 }}>
        <Breadcrumb
          crumbs={[{ label: 'Home', link: '/' }, { label: 'Archived Report' }]}
        />
      </Box>

      <Box color="primary" pt={4} pb={4} sx={{ textAlign: 'center' }}>
        <Text sx={{ fontSize: '1.8rem' }}>
          <BsFillFileEarmarkTextFill /> ARCHIVED LAPORAN PENGADUAN
        </Text>
      </Box>

      <Box>
        <PanelComponent header="Laporan Pengaduan Anda Yang Archived" mt={3}>
          <Table
            options={{
              initialState: {
                pageSize: 10,
              },
              columns: columns,
              data: dataReports,
            }}
            totalData={dataApi?.data?.total}
          />
        </PanelComponent>
      </Box>
    </Container>
  )
}

export default ListArchivedLaporanPengaduan
